<script>
  export default {
    props: {
      lines: {
        type: Array,
        default: () => [],
      },
      uid: {
        type: Number,
        required: true,
      },
      navs: {
        type: Array,
        default: () => [],
      },
      backgroundColour: {
        type: String,
        default: '',
      },
      expanded: {
        type: Boolean,
        default: false,
      },
      myIndex: {
        type: Number,
        required: true,
      },
      myIndexLast: {
        type: Number,
        required: true,
      },
    },
    computed: {
      snakeCaseRegex () {
        return new RegExp(/({[a-zA-Z_]*})/)
      },
      showContracted () {
        if (this.myIndexLast < 5){
          return true
        }
        return this.myIndex === 0 || this.myIndex === 1 || this.myIndex === this.myIndexLast - 1 || this.myIndex === this.myIndexLast
      },
      first(){
        return this.myIndex === 0;
      },
      second(){
        return this.myIndex === 1;
      },
      secondLast(){
        return this.myIndex === this.myIndexLast - 1;
      },
      last(){
        return this.myIndex === this.myIndexLast;
      },
    },
    methods: {
      resolveLine(line, navs){
        const replacementKeyMap = new Map();
        const lineHasNavLink = this.hasNavLink(navs)
        let navLine = line;
        if (lineHasNavLink){
          navs.forEach(nav => {
            const navKey = `{${nav.key}}`
            if (navLine.includes(navKey)){
              const navLink = nav.label;
              replacementKeyMap.set(navKey, this.generateLink(nav))
              navLine = navLine.replace(navKey, navLink)
            }
          });
        }

        const para = line.split(this.snakeCaseRegex)
        const ce = this.$createElement
        const message = ce(
          'p',
          { class: ['tw-mb-0'] },
          [
            para.map(function(line){
              if (line === ''){
                return
              }
              if (replacementKeyMap.has(line)){
                return replacementKeyMap.get(line)
              }
              return line
            }),
          ]
        )

        return message
      },
      hasNavLink(navs){
        if (navs && navs.length !== 0){
          return true
        }
        return false
      },
      generateLink(nav){
        const ce = this.$createElement
        const item = this.parsNavToItem(nav)
        let params = {};
        if (this.isProjectDocument(nav)) {
          params = { id: nav.project }
        }
        const routerObject = { 
          props: { to: {}},
          class: ""
        }
        routerObject.props.to = this.resolveRouterObjectForDocument(item, params);
        routerObject.class="tx-td-underline tx-col-black"
        return ce('b-link', routerObject, `${nav.label}`);
      },
      parsNavToItem(nav){
        const item = {}
        item.type = this.resolveDocumentKeyForSnakeCase(nav.key)
        item.documentId = nav.id
        return item
      },
      isProjectDocument(nav){
        if (nav && nav.key && ['invoice_order','purchase_order','quote','sale_order'].indexOf(nav.key) !== -1 ){
          return true
        }
        return false
      },
    },
  }
</script>

<template>
  <section :class="[{ 'pd-y-5': myIndex === 2 && !expanded && !showContracted }]">
    <div 
      v-if="showContracted || myIndex === 2 || expanded"
      :class="['timeline-item-wrapper mx-4', backgroundColour, { 'first-item': first, 'second-item': second && !expanded, 'second-last-item': secondLast && !expanded, 'last-item': last, 'view-more': myIndex === 2 && myIndexLast !== 4 && !showContracted && !expanded }]">
      <li 
        v-if="showContracted || expanded"
        :class="['timeline-item pd-b-5']">
        <div 
          v-for="(line, index) in lines"
          :key="index"
          :class="['timeline-item-title', backgroundColour, { 'text-bold': index === 0 }, { 'text-dark': index !== 0 }]"><BaseCreateElement :nodes="resolveLine(line, navs)" />
        </div>
      </li>
      <li
        v-if="myIndex === 2 && !expanded && !showContracted"
        class="timeline-item view-more">
        <div :class="['timeline-item-title text-dark fl-columns', backgroundColour]"><br><span class="curs-p" @click="$emit('set-expanded')">Show More</span><br>
        </div>
      </li>
    </div>
  </section>
</template>
